import './index.scss';

import React from 'react';

import Flex from '@ui-pc/Flex';
import Switch from '@ui-pc/Switch';
import Text from '@ui-pc/Text';

import { ctx } from '../../utils';
import { Distribution, ReviesPercent } from './ReviesPercent';
import { ReviewsStat } from './ReviewsStat';

export type PanelProps = {
  /**
   * 总评分数
   */
  score: string
  /**
   * 评分总人数
   */
  reviewNum: string
  /**
   * 从1-5不同星级的评分数量
   */
  reviewsDistribution: [
    Distribution,
    Distribution,
    Distribution,
    Distribution,
    Distribution
  ]
}

function Index() {
  const [state] = ctx.useState()
  return (
    <Flex className="ind-widget-panel">
      <Switch either={Number(state.reviewNum) > 0}>
        <Flex alignItems="center" warp={false}>
          <ReviewsStat />
          <ReviesPercent />
          <div className="widget-line-box">
            <div className="widget-line" />
          </div>
        </Flex>
      </Switch>
    </Flex>
  )
}

export default Index
